var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box11"},[_c('zs'),_c('hidden-govern'),_c('ks'),_c('px'),_c('fxyp'),_c('xj'),_c('synx'),_c('whby'),_c('dclzy')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }